import React, { useState } from 'react';
import axiosInstance from '../../axiosConfig';
import { useNavigate } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Alert } from '@mui/material';
import API_URL from '../../config';

function ForgotPassword({ open, handleClose }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate(); // ⬅ NEU: useNavigate für die Weiterleitung

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage(null);
    setError(null);

    try {
      const response = await axiosInstance.post('/auth/request-password-reset', { email });
      setMessage(response.data.message);
    } catch (error) {
      setError("Fehler beim Anfordern des Passwort-Resets. Bitte versuchen Sie es erneut.");
    }
    setTimeout(() => {
      handleClose();
      navigate('/pages/login');
    }, 3000);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Passwort zurücksetzen</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <DialogContentText>
          Geben Sie Ihre E-Mail-Adresse ein. Falls die Adresse existiert, senden wir einen Link zum Zurücksetzen.
        </DialogContentText>
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          autoFocus
          required
          margin="dense"
          id="email"
          name="email"
          label="E-Mail-Adresse"
          placeholder="Ihre E-Mail-Adresse"
          type="email"
          fullWidth
          variant="outlined"
          autoComplete="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError(null); // Zurücksetzen, wenn Nutzer tippt
          }}
          error={!!error || (email.length > 0 && !/^\S+@\S+\.\S+$/.test(email))}
          helperText={error || (email.length > 0 && !/^\S+@\S+\.\S+$/.test(email) ? 'Bitte geben Sie eine gültige E-Mail-Adresse ein.' : '')}
        />

      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>Abbrechen</Button>
        <Button variant="contained" type="submit" onClick={handleSubmit} disabled={!email || !/^\S+@\S+\.\S+$/.test(email)}>
          Absenden
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ForgotPassword;
